import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AvatarEditor } from "../components/AvatarEditor";
import { useLocalProfile } from "../local/useLocalProfile";
import { createProfile } from "../local/profile";
import type { AvatarConfig } from "@shared/types";

export function LocalCreate() {
  const nav = useNavigate();
  const { profile, setProfile } = useLocalProfile();
  const [name, setName] = useState(profile?.displayName ?? "");
  const [avatar, setAvatar] = useState<AvatarConfig>(profile?.avatarConfig ?? {});
  const [err, setErr] = useState<string | null>(null);

  const start = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setErr("Pick a name");
      return;
    }
    setProfile(createProfile(trimmed, avatar));
    nav("/", { replace: true });
  };

  return (
    <div className="home-dashboard create-page">
      <div className="create-panel stack">
      <h1>
        {profile ? "Make a new character" : "Make your character"}
      </h1>
        <input
          className="input"
          autoFocus
          placeholder="Your name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={20}
          style={{ textAlign: "center" }}
        />
        <AvatarEditor initial={avatar} controlledOnly onChange={setAvatar} />
        {err && <div className="error t-center">{err}</div>}
        <button className="btn btn-primary btn-big btn-block" onClick={start}>
          Start playing →
        </button>
        {profile && (
          <button className="btn btn-ghost btn-block" onClick={() => nav("/")}>
            ← Back without saving
          </button>
        )}
      </div>
    </div>
  );
}
